import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { ChatEmitterService } from '@app/core/services/chat-emitter.service';
import { HelperService } from "@app/core/services/helper.service";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { AppConfig } from '@app/core/Utilities/app-config.service';
import { AgentDetailComponent } from "@app/modules/agent/pages/agent-detail/agent-detail.component";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-inbox",
  templateUrl: "./inbox.component.html",
  styleUrls: ["./inbox.component.scss"],
})
export class InboxComponent implements OnInit {
  messageList = [];
  messageDetail;
  isDataLoaded = false;
  isMessageDetailLoaded = false;
  selectedMessage = 0;
  bsModalRef: BsModalRef;
  constructor(
    private messageCenterService: MessageCenterService,
    private sanit: DomSanitizer,
    private helperService: HelperService,
    private router: Router,
    private modalService: BsModalService,
    private chatEmitterService: ChatEmitterService,
    private appConfig: AppConfig
  ) { }

  ngOnInit() {
    this.getMessages();
    if (this.chatEmitterService.inboxListSubscription === undefined) {
      this.chatEmitterService.inboxListSubscription = this.chatEmitterService.inboxCount.subscribe(
        (data) => {
          this.getMessages();
          this.updateInboxCount();
        }
      );
    }
  }

  getMessages() {
    this.messageCenterService.getMessages().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.isDataLoaded = true;
        this.messageList = result.Data;
        if (
          this.messageList.length > 0 && this.selectedMessage === 0 &&
          !this.helperService.isUndefinedOrNullOrEmpty(this.messageList[0].ID)
        ) {
          this.selectedMessage = this.messageList[0].ID;
          this.openMessage(this.selectedMessage, this.messageList[0].IsRead);
        }
      } else {
        this.messageList = [];
      }
    });
  }

  updateInboxCount() {
    this.messageCenterService.updateInboxCount();
  }

  readMessage(id) {
    this.messageCenterService.readMessage(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.getMessages();
        if (this.appConfig.SharedComponent.inboxCount > 0) {
          this.appConfig.SharedComponent.inboxCount--;
        }
      }
    });
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
    }
  }

  openMessage(id, isRead) {
    this.selectedMessage = id;
    if (!isRead) { this.readMessage(id); }
    // this.messageDetail = _.filter(this.messageList, [
    //   "ID",
    //   this.selectedMessage,
    // ])[0];

    this.getMessagesById(this.selectedMessage);
  }

  getMessagesById(id) {
    this.isMessageDetailLoaded = false;
    this.messageCenterService
      .getMessagesById(id)
      .subscribe((result) => {
        this.isMessageDetailLoaded = true;
        if (result.Status === ResultStatus.Success) {
          this.messageDetail = result.Data;
        } else {
          this.messageDetail = null;
        }
      });
  }

  openMessageDetail(id, isRead) {
    if (!isRead) { this.readMessage(id); }
    this.router.navigate([`/inbox/message/detail/${id}`]);
  }
}
